export enum char {
  new_line = '\r\n|\r|\n|[\n\u2028\u2029]',
  mdash = '\u2014',
}

export const TRUNCATE_ELLIPSIS: string = '[...]';
